import { createActions } from 'redux-actions';

export const {
    setGlobalState, setBusinessUnitId, setBusinessUser, setAccessError, setAccessErrorSuccess
}: any = createActions({
    SET_GLOBAL_STATE: (state) => ({
        state,
    }),
    SET_BUSINESS_UNIT_ID: (businessUnitId) => ({
        businessUnitId,
    }),
    SET_BUSINESS_USER: (businessUser) => ({
        businessUser
    }),
    SET_ACCESS_ERROR: (failedBusinessUnitId) => ({
        failedBusinessUnitId,
    }),
    SET_ACCESS_ERROR_SUCCESS: (accessError) => ({
        accessError,
    }),
});



// WEBPACK FOOTER //
// ./src/Actions/App/index.ts